import {
  faCompass,
  faEye,
  faMoon,
  faSnowflake,
  faSun,
  faThermometerEmpty,
  faThermometerFull,
  faWind,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SignificantWeatherIcon from "../../assets/icons/weather_conditions_icons/significant_weather-01.svg2";
import WindSpeedIcon from "../../assets/icons/weather_conditions_icons/wind_speed-01.svg2";
import windDirectionIcon from "../../assets/icons/weather_conditions_icons/wind_direction.svg2";
import MaxScreenTempIcon from "../../assets/icons/weather_conditions_icons/max_screen_temp-01.svg2";
import VisibilityIcon from "../../assets/icons/visibility.svg2";
import MinScreenTempIcon from "../../assets/icons/weather_conditions_icons/min_screen_temp-01.svg2";
import ProbOfSnowVsibilityIcon from "../../assets/icons/weather_conditions_icons/probability_of_snow_visibility-01.svg2";
import ClearSkyIcon from "../../assets/icons/weather_conditions_icons/clear_sky-01.svg2";
import SunnyIcon from "../../assets/icons/weather_conditions_icons/sunny-01.svg2";
import PartlyCloudIcon from "../../assets/icons/weather_conditions_icons/partly_cloudy-01.svg2";
import MistIcon from "../../assets/icons/weather_conditions_icons/mist-01.svg2";
import FogIcon from "../../assets/icons/weather_conditions_icons/fog-01.svg2";
import CloudyIcon from "../../assets/icons/weather_conditions_icons/cloudy-01.svg2";
import OvercastIcon from "../../assets/icons/weather_conditions_icons/overcast-01.svg2";
import LightRainIcon from "../../assets/icons/weather_conditions_icons/light_rain-01.svg2";
import DrizzleIcon from "../../assets/icons/weather_conditions_icons/drizzle-01.svg2";
import HeavyRainShowerIcon from "../../assets/icons/weather_conditions_icons/heavy_rain_shower-01.svg2";
import HeavyRainIcon from "../../assets/icons/weather_conditions_icons/heavy_rain-01.svg2";
import SleetShowerIcon from "../../assets/icons/weather_conditions_icons/sleet_shower-01.svg2";
import SleetIcon from "../../assets/icons/weather_conditions_icons/sleet-01.svg2";
import HailShowerIcon from "../../assets/icons/hail.svg2"; // placeholder
import HailIcon from "../../assets/icons/hail.svg2";
import LightSnowShowerIcon from "../../assets/icons/weather_conditions_icons/light_snow_shower-01.svg2";
import LightSnow from "../../assets/icons/weather_conditions_icons/light_snow-01.svg2";
import HeavySnowShowerIcon from "../../assets/icons/weather_conditions_icons/heavy_snow_shower-01.svg2";
import HeavySnowIcon from "../../assets/icons/weather_conditions_icons/heavy_snow-01.svg2";
import ThunderShowerIcon from "../../assets/icons/weather_conditions_icons/thunder_shower-01.svg2";
import ThunderIcon from "../../assets/icons/weather_conditions_icons/thunder-01.svg2";

export const WindDirections = [
  { direction: "North (N)", degrees: 0 },
  { direction: "North-Northeast (NNE)", degrees: 22.5 },
  { direction: "Northeast (NE)", degrees: 45 },
  { direction: "East-Northeast (ENE)", degrees: 67.5 },
  { direction: "East (E)", degrees: 90 },
  { direction: "East-Southeast (ESE)", degrees: 112.5 },
  { direction: "Southeast (SE)", degrees: 135 },
  { direction: "South-Southeast (SSE)", degrees: 157.5 },
  { direction: "South (S)", degrees: 180 },
  { direction: "South-Southwest (SSW)", degrees: 202.5 },
  { direction: "Southwest (SW)", degrees: 225 },
  { direction: "West-Southwest (WSW)", degrees: 247.5 },
  { direction: "West (W)", degrees: 270 },
  { direction: "West-Northwest (WNW)", degrees: 292.5 },
  { direction: "Northwest (NW)", degrees: 315 },
  { direction: "North-Northwest (NNW)", degrees: 337.5 },
];

// day, night, both (day and night) ,
// if both then select (night)
export const WeatherCodes = [
  { value: 0, label: "Clear sky", time: "night", icon: ClearSkyIcon },
  { value: 1, label: "Sunny", time: "day", icon: SunnyIcon },
  { value: 2, label: "Partly cloudy", time: "night", icon: PartlyCloudIcon },
  { value: 3, label: "Partly cloudy", time: "day", icon: PartlyCloudIcon },
  { value: 5, label: "Mist", time: null, icon: MistIcon },
  { value: 6, label: "Fog", time: null, icon: FogIcon },
  { value: 7, label: "Cloudy", time: null, icon: CloudyIcon },
  { value: 8, label: "Overcast", time: null, icon: OvercastIcon },
  { value: 9, label: "Light rain shower", time: "night", icon: LightRainIcon },
  { value: 10, label: "Light rain shower", time: "day", icon: LightRainIcon },
  { value: 11, label: "Drizzle", time: null, icon: DrizzleIcon },
  { value: 12, label: "Light rain", time: null, icon: LightRainIcon },
  {
    value: 13,
    label: "Heavy rain shower",
    time: "night",
    icon: HeavyRainShowerIcon,
  },
  {
    value: 14,
    label: "Heavy rain shower",
    time: "day",
    icon: HeavyRainShowerIcon,
  },
  { value: 15, label: "Heavy rain", time: null, icon: HeavyRainIcon },
  { value: 16, label: "Sleet shower", time: "night", icon: SleetShowerIcon },
  { value: 17, label: "Sleet shower", time: "day", icon: SleetShowerIcon },
  { value: 18, label: "Sleet", time: null, icon: SleetIcon },
  { value: 19, label: "Hail shower", time: "night", icon: HailShowerIcon },
  { value: 20, label: "Hail shower", time: "day", icon: HailShowerIcon },
  { value: 21, label: "Hail", time: null, icon: HailIcon },
  {
    value: 22,
    label: "Light snow shower",
    time: "night",
    icon: LightSnowShowerIcon,
  },
  {
    value: 23,
    label: "Light snow shower",
    time: "day",
    icon: LightSnowShowerIcon,
  },
  { value: 24, label: "Light snow", time: null, icon: LightSnow },
  {
    value: 25,
    label: "Heavy snow shower",
    time: "night",
    icon: HeavySnowShowerIcon,
  },
  {
    value: 26,
    label: "Heavy snow shower",
    time: "day",
    icon: HeavySnowShowerIcon,
  },
  { value: 27, label: "Heavy snow", time: null, icon: HeavySnowIcon },
  {
    value: 28,
    label: "Thunder shower",
    time: "night",
    icon: ThunderShowerIcon,
  },
  { value: 29, label: "Thunder shower", time: "day", icon: ThunderShowerIcon },
  { value: 30, label: "Thunder", time: null, icon: ThunderIcon },
];

export const WeatherAlertConditions = [
  {
    key: "daySignificantWeatherCode",
    label: "Significant Weather",
    description:
      "The most likely significant weather during daytime, based on ensemble data.",
    unit: "",
    icon: SignificantWeatherIcon,
    codes: WeatherCodes,
    isDay: true,
  },
  {
    key: "nightSignificantWeatherCode",
    label: "Significant Weather",
    description:
      "The most likely significant weather during nighttime, based on ensemble data.",
    unit: "",
    icon: SignificantWeatherIcon,
    codes: WeatherCodes,
    isDay: false,
  },
  {
    key: "midday10MWindSpeed",
    label: "Wind Speed",
    description:
      "The expected wind speed at 10 meters above ground level at midday (12:00 UTC).",
    unit: "m/s (meters per second)",
    icon: WindSpeedIcon,
    isDay: true,
  },
  {
    key: "midnight10MWindSpeed",
    label: "Wind Speed",
    description:
      "The expected wind speed at 10 meters above ground level at midnight (00:00 UTC).",
    unit: "m/s (meters per second)",
    icon: WindSpeedIcon,
    isDay: false,
  },
  {
    key: "midday10MWindDirection",
    label: "Wind Direction",
    description:
      "The expected wind direction at 10 meters above ground level at midday (12:00 UTC).",
    unit: "° (degrees from North)",
    icon: windDirectionIcon,
    windDirections: WindDirections,
    isDay: true,
  },
  {
    key: "midnight10MWindDirection",
    label: "Wind Direction",
    description:
      "The expected wind direction at 10 meters above ground level at midnight (00:00 UTC).",
    unit: "° (degrees from North)",
    icon: windDirectionIcon,
    windDirections: WindDirections,
    isDay: false,
  },
  {
    key: "dayMaxScreenTemperature",
    label: "Max Screen Temperature",
    description:
      "The most likely maximum air temperature during the day at 1.5 meters above ground level.",
    unit: "°C (degrees Celsius)",
    icon: MaxScreenTempIcon,
    isDay: true,
  },
  {
    key: "midnightVisibility",
    label: "Visibility",
    label: "Visibility",
    description: "The expected visibility distance at midnight (00:00 UTC).",
    unit: "m (meters)",
    icon: VisibilityIcon,
    isDay: false,
  },
  {
    key: "nightMinScreenTemperature",
    label: "Min Screen Temperature",
    description:
      "The most likely minimum air temperature during the night at 1.5 meters above ground level.",
    unit: "°C (degrees Celsius)",
    icon: MinScreenTempIcon,
    isDay: false,
  },
  {
    key: "nightProbabilityOfSnow",
    label: "Probability of Snow",
    description: "The probability of snowfall occurring during the night.",
    unit: (
      <>
        <div>
          % <div>(percentage)</div>
        </div>
      </>
    ),
    icon: ProbOfSnowVsibilityIcon,
    isDay: false,
  },
  {
    key: "dayProbabilityOfSnow",
    label: "Probability of Snow",
    description: "The probability of snowfall occurring during the day.",
    unit: (
      <>
        <div>
          % <div>(percentage)</div>
        </div>
      </>
    ),
    icon: ProbOfSnowVsibilityIcon,
    isDay: true,
  },
  {
    key: "middayVisibility",
    label: "Visibility",
    description: "The expected visibility distance at midday (12:00 UTC).",
    unit: "m (meters)",
    icon: VisibilityIcon,
    isDay: true,
  },
];

export const WeatherAlertOperators = [
  {
    symbol: ">=",
    desc: "Greater than or equals to",
  },
  {
    symbol: "<=",
    desc: "Less than or equals to",
  },
  {
    symbol: ">",
    desc: "Greater than",
  },
  {
    symbol: "<",
    desc: "Less than",
  },
  {
    symbol: "=",
    desc: "Equals to",
  },
  {
    symbol: "between",
    desc: "Between",
  },
];

// Function to get the proper icon and helper text based on time of day selection
export const getConditionDisplay = (condition, timeOfDay, allConditions) => {
  if (!condition || !condition.icon) {
    console.warn(
      "Invalid condition object provided to getConditionDisplay",
      condition
    );
    return { icons: [], helper: "" };
  }

  let icons = [condition.icon]; // Default to single icon
  let helper = condition.description;

  // For "Day and Night" mode
  if (timeOfDay === "both") {
    // Check if there's a corresponding day/night pair for this condition
    let pair = null;

    // For day conditions, find the night counterpart
    if (condition.isDay) {
      const nightKey = condition.key
        .replace("day", "night")
        .replace("midday", "midnight");
      pair = allConditions.find((c) => c.key === nightKey);
    }
    // For night conditions, find the day counterpart
    else {
      const dayKey = condition.key
        .replace("night", "day")
        .replace("midnight", "midday");
      pair = allConditions.find((c) => c.key === dayKey);
    }

    // If we found a pair and the icons are different, show both
    if (pair && pair.icon !== condition.icon) {
      icons = condition.isDay
        ? [condition.icon, pair.icon]
        : [pair.icon, condition.icon];
    }

    // Make description more generic
    helper = helper
      .replace("during daytime", "throughout the day and night")
      .replace("during the day", "throughout the day and night")
      .replace("during nighttime", "throughout the day and night")
      .replace("during the night", "throughout the day and night")
      .replace("at midday (12:00 UTC)", "")
      .replace("at midnight (00:00 UTC)", "");
  }

  return { icons, helper };
};

export const renderCondition = (condition, timeOfDay) => {
  // Get the appropriate display for this condition
  const display = getConditionDisplay(
    condition,
    timeOfDay,
    WeatherAlertConditions
  );

  return (
    <span className="text-muted ps-1">
      {display.icons.length === 1 && typeof display.icons[0] === "object" ? (
        <FontAwesomeIcon icon={display.icons[0]} />
      ) : (
        <>
          {typeof display.icons[0] === "object" && (
            <FontAwesomeIcon icon={display.icons[0]} className="me-1" />
          )}
          {typeof display.icons[1] === "object" && (
            <FontAwesomeIcon icon={display.icons[1]} />
          )}
        </>
      )}{" "}
      {display.helper}
    </span>
  );
};

export const WeatherForecastOptions = [
  // {
  //   value: "temperature",
  //   label: "Temperature",
  //   icon: SunnyIcon,
  // },
  {
    value: "wind",
    label: "Wind",
    icon: windDirectionIcon,
    unit: "m/s",
  },
  {
    value: "feelsLikeTemp",
    label: "Feels Like Temperature",
    icon: MaxScreenTempIcon,
    unit: "°C",
  },
  {
    value: "maxScreenAirTemp",
    label: "Max Screen Air Temperature",
    icon: MaxScreenTempIcon,
    unit: "°C",
  },
  {
    value: "minScreenAirTemp",
    label: "Min Screen Air Temperature",
    icon: MinScreenTempIcon,
    unit: "°C",
  },
  {
    value: "mslp",
    label: "Mean Sea Level Pressure",
    icon: MaxScreenTempIcon,
    unit: "Pa",
  },
  {
    value: "max10mWindGust",
    label: "Max 10m Wind Gust",
    icon: windDirectionIcon,
    unit: "m/s",
  },

  {
    value: "probOfHail",
    label: "Probability of Hail",
    icon: HailIcon,
    unit: "%",
  },
  {
    value: "probOfHeavyRain",
    label: "Probability of Heavy Rain",
    icon: HeavyRainIcon,
    unit: "%",
  },
  {
    value: "probOfHeavySnow",
    label: "Probability of Heavy Snow",
    icon: HeavySnowIcon,
    unit: "%",
  },
  {
    value: "probOfPrecipitation",
    label: "Probability of Precipitation",
    icon: ProbOfSnowVsibilityIcon,
    unit: "%",
  },
  {
    value: "probOfRain",
    label: "Probability of Rain",
    icon: LightRainIcon,
    unit: "%",
  },
  {
    value: "probOfSferics",
    label: "Probability of Sferics",
    icon: ThunderIcon,
    unit: "%",
  },
  {
    value: "probOfSnow",
    label: "Probability of Snow",
    icon: LightSnow,
    unit: "%",
  },
  {
    value: "screenRelativeHumidity",
    label: "Screen Relative Humidity",
    icon: ProbOfSnowVsibilityIcon,
    unit: "%",
  },
  {
    value: "significantWeatherCode",
    label: "Significant Weather Code",
    icon: SignificantWeatherIcon,
    unit: "",
  },
  {
    value: "totalPrecipAmount",
    label: "Total Precipitation Amount",
    icon: ProbOfSnowVsibilityIcon,
    unit: "mm",
  },
  {
    value: "totalSnowAmount",
    label: "Total Snow Amount",
    icon: LightSnow,
    unit: "mm",
  },
  { value: "uvIndex", label: "UV Index", icon: SunnyIcon, unit: "(UV index)" },
  {
    value: "visibility",
    label: "Visibility",
    icon: VisibilityIcon,
    unit: "m",
  },
  {
    value: "windDirectionFrom10m",
    label: "Wind Direction From 10m",
    icon: windDirectionIcon,
    unit: "°",
  },
  {
    value: "windGustSpeed10m",
    label: "Wind Gust Speed 10m",
    icon: windDirectionIcon,
    unit: "m/s",
  },
  {
    value: "windSpeed10m",
    label: "Wind Speed 10m",
    icon: windDirectionIcon,
    unit: "m/s",
  },
];
